import {
  accessTokenService,
  refreshTokenService,
  clientIdService,
} from '@shared/lib/storage';

// Clears the whole session and hard-redirects to the login page. The full page
// reload also wipes the React Query cache and every in-memory store, so no
// explicit cache reset is needed here.
export const logout = () => {
  accessTokenService.remove();
  refreshTokenService.remove();
  clientIdService.remove();

  window.location.assign('/login');
};
